export const bieresData = [
  {
    image: '/assets/lorraine-blonde.png',
    name: 'LORRAINE BLONDE',
    name_yellow: 'LORRAINE ',
    name_white: 'BLONDE',
    profil: 'Bière blonde lager à 5°. Très rafraîchissante, caractérisée par une subtile amertume.',
    arome: 'Des notes subtiles de céréales en fin de bouche apportées par un équilibre maîtrisé entre le malt et le houblon sélectionné',
    robe: 'Blond pâle aux reflets dorés. Mousse fine et délicate.',
    leplus: 'A déguster avec un quartier de citron pour encore plus de fraîcheur !',
    id: 1,
  },
  {
    image: '/assets/lorraine-ice2025.png',
    name: 'LORRAINE ICE',
    name_yellow: 'LORRAINE ',
    name_white: 'ICE',
    profil: 'Bière blonde à 4,2°, sans amertume. Douce et légère.',
    arome: 'Des notes subtiles de céréales en fin de bouche apportées par un équilibre maîtrisé entre le malt et le houblon sélectionné',
    robe: 'Blond pâle aux reflets dorés. Mousse fine et délicate.',
    leplus: 'A déguster avec un quartier de citron pour encore plus de fraîcheur !',
    id: 2,
  },
  {
    image: '/assets/lorraine-ambree.png',
    name: 'LORRAINE AMBRÉE',
    name_yellow: 'LORRAINE ',
    name_white: 'AMBRÉE',
    profil: 'Bière ambrée à 5°, ronde et gourmande , au caractère bien affirmé !',
    arome: 'Notes de caramel, apportées par la variété de malt sélectionnée.',
    robe: 'Dorée et éclatante. Mousse épaisse et persistante.',
    leplus: 'De belles notes sucrées, aussi surprenantes que douces.',
    id: 3,
  },
  {
    image: '/assets/malta-lorraine.png',
    name: 'MALTA LORRAINE',
    name_yellow: 'MALTA ',
    name_white: 'LORRAINE',
    profil: 'Boisson maltée rafraîchissante sans alcool.',
    arome: 'Subtiles notes de caramel et de chocolat, apportées par la variété de malt sélectionnée.',
    robe: 'Sombre aux reflets intenses. Mousse fine et discrète.',
    leplus: 'Apport de vitamines quotidien. Teneur garantie en vitamine B6',
    id: 4,
  },
  {
    image: '/assets/lorraine-gingembre.png',
    name: 'Malta Lorraine Gingembre',
    name_yellow: 'MALTA ',
    name_white: 'GINGEMBRE',
    profil: 'Boisson maltée sans alcool aromatisée au gingembre',
    arome: "Subtiles notes acidulées et épicées apportées par l'extrait de gingembre sélectionné.",
    robe: 'Brune aux reflets intenses. Mousse fine et vivifiante.',
    leplus: "Apport de fraîcheur et d'énergie. Teneur garantie en vitamine B6.",
    id: 5,
  },
   {
    image: '/assets/malta-cafe.png',
    name: 'Malta Lorraine Café',
    name_yellow: 'MALTA ',
    name_white: ' CAFÉ',
    profil: 'Boisson maltée sans alcool aromatisée au café',
    arome: "Notes de café fraîchement moulu, de malt torréfié, et de céréales grillées.",
    robe: 'Brune foncé, profonde, aux reflets acajou',
    leplus: "Apport de vitamines quotidien. Teneur garantie en vitamine B6",
    id: 6,
  },
];
